import { useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getProviderTrackingLink } from '../../use-cases/getProviderTrackingLink'

export function useProviderTrackingLink(shipmentUuid: string) {
  const { call, result, status, error } = useAsync(getProviderTrackingLink)
  const abortController = useAbortController()

  useEffect(() => {
    call(shipmentUuid, abortController)
  }, [shipmentUuid, call, abortController])

  return { trackingLink: result, status, error }
}
